var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHealthAndBeautyinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M27 46H15.25c-1.243 0-2.25-.977-2.25-2.182V24.182C13 22.977 14.007 22 15.25 22h13.5c1.243 0 2.25.977 2.25 2.182v1.578"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27 52H11.615C9.066 52 7 49.985 7 47.5v-27c0-2.485 2.066-4.5 4.615-4.5h20.77C34.934 16 37 18.015 37 20.5V26"
}), /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 4,
  x: 11,
  y: 7,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 11v4m14-4v4"
}), /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 24,
  x: 27,
  y: 33,
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 6,
  x: 27,
  y: 27,
  rx: 3
}))));
export default SvgHealthAndBeautyinline;